/** 모달 ALERT **/
import BASE from '@/components/common/modal/alert/base/index.vue';
import CONFIRM from '@/components/common/modal/alert/confirm/index';
import MENU from '@/components/common/modal/menu/index';
import TERMS from '@/components/common/modal/terms/index';
import PRIVATE from '@/components/common/modal/private/index';
import SERVICE from '@/components/common/modal/service/index';
import PUSH_CONFIRM from '@/components/common/modal/alert/confirm/pushConfirm';
import LOADING from '@/components/common/modal/loading/index';
import POPUP from '@/components/common/modal/popup/popup';
import LOGOUT from '@/components/common/modal/alert/confirm/logout';
import PASSWORD_UPDATE_FORM from '@/components/common/modal/updatePassword/index.vue';
import UPDATE from '@/components/common/modal/alert/update/index';

export const modalAlertNames = {
  BASE,
  CONFIRM,
  TERMS,
  PUSH_CONFIRM,
  POPUP,
  LOGOUT,
  UPDATE,
  PASSWORD_UPDATE_FORM
};

export const modalNames = {
  LOADING,
  MENU,
  PRIVATE,
  SERVICE
};
